// AUTO-GENERATED by .claude/seed-life-connect.mjs — do not edit by hand.
// Per-mission Overview content for the Life Connect (adb) demo missions.

export const PLANS_BY_MISSION_LC = {
  "lc-mis-decision-archi": {
    "reframe": "Life Connect : choisir entre une gestion unifiée des baux (résidentiel ET commercial) ou deux modules séparés, en arbitrant time-to-market et coût de maintenance.",
    "synthesis": "2 options chiffrées. Socle unifié + extension commerciale : moins cher à maintenir, quelques compromis UX sur le commercial. Modules séparés : plus net mais ~2× le coût de build. La reco penche unifié modulaire.",
    "validated": [
      "~70 % des besoins baux sont communs",
      "Le commercial ajoute ILC/ILAT, refacturation taxes, 3-6-9",
      "Reco : socle unifié + extension commerciale"
    ],
    "produces": "Une reco → engendre les Goal(s) « Baux non commerciaux » puis « Baux commerciaux ».",
    "steps": {
      "appetite": "Appétit : « App unifiée résidentiel + commercial ? » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 0 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 0 story(ies) en cours, 0 livrée(s) sur 0.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-question-reprise": {
    "reframe": "Life Connect : estimer le coût, la durée et les risques de la reprise des données depuis SPI pour les 4 portefeuilles (Digital Immo, Bertolo, ImmoCore, VFund Immo1).",
    "synthesis": "TCO de la reprise modélisé. Poste dominant : la fiabilisation des soldes comptables hérités. Risque #1 : des anomalies SPI non détectées (déjà observées au pilote l’an dernier).",
    "validated": [
      "~784 lots sur 4 parcs",
      "Reprise des soldes = poste de risque dominant",
      "Stratégie : parc par parc, du plus petit au plus grand"
    ],
    "produces": "Une synthèse → engendre le Goal « Reprise de parc ».",
    "steps": {
      "appetite": "Appétit : « Coût & risque de la reprise des 4 parcs ? » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 0 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 0 story(ies) en cours, 0 livrée(s) sur 0.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-idea-portail": {
    "reframe": "Life Connect : tester l’intérêt d’un portail locataire self-service (quittances, paiement, demandes d’intervention) avant d’investir dans le build.",
    "synthesis": "Aujourd’hui les locataires passent par email/téléphone. Hypothèse : un self-service réduit de ~20 % les sollicitations à l’équipe de gestion. À valider par un test léger.",
    "validated": [
      "Friction actuelle : email/téléphone",
      "Gain visé : −20 % de sollicitations",
      "Test léger avant tout build"
    ],
    "produces": "Un verdict kill / refine / proceed → si proceed, engendre un prototype puis un Goal.",
    "steps": {
      "appetite": "Appétit : « Portail locataire self-service ? » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 0 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 0 story(ies) en cours, 0 livrée(s) sur 0.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-review-bascule": {
    "reframe": "Life Connect : décider go/no-go de l’arrêt de SPI et de la bascule comptable au 1ᵉʳ janvier, sur la base des cycles de gestion parallèle.",
    "synthesis": "Critère de bascule : 3 cycles complets sans anomalie sur le pilote. Cycle 1 OK, cycle 2 en cours, écarts résiduels en correction. Go conditionné à un cycle 3 propre.",
    "validated": [
      "Critère : 3 cycles sans anomalie",
      "Cycles 1-2 : écarts en réduction",
      "Fenêtre : prochain 1ᵉʳ janvier (sinon +1 an)"
    ],
    "produces": "Un verdict → engendre la reprise comptable finale + l’arrêt de SPI.",
    "steps": {
      "appetite": "Appétit : « Go/no-go bascule comptable (1ᵉʳ janvier) » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 1 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 0 story(ies) en cours, 0 livrée(s) sur 1.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-baux-comm": {
    "reframe": "Life Connect : livrer la gestion des baux commerciaux (3-6-9) — clauses, révisions ILC/ILAT, refacturation des charges et taxes — validée d’abord sur Bertolo (5 lots, 2 commerciaux).",
    "synthesis": "Le commercial est le verrou réglementaire : cadrage juriste requis. Périmètre découpé en slices : spécification → clauses/révisions → refacturation → pilote Bertolo.",
    "validated": [
      "Cadrage juriste sur le 3-6-9",
      "Indices ILC/ILAT + clause d’échelle mobile",
      "Pilote : Bertolo (le plus simple)"
    ],
    "produces": "Un module commercial → engendre une Maintain (gestion courante des baux commerciaux).",
    "steps": {
      "appetite": "Appétit : « Baux commerciaux (3-6-9) » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 3 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 0 story(ies) en cours, 0 livrée(s) sur 3.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-anomalies": {
    "reframe": "Life Connect : cadrer comment éliminer les anomalies de quittancement vues sur Digital Immo l’an dernier — incohérences de montant sur les lots à charges provisionnelles.",
    "synthesis": "La gestion en parallèle (SPI vs Life Connect) sert de filet : chaque écart est qualifié puis routé. La cause racine se concentre sur la ventilation des charges.",
    "validated": [
      "Filet : gestion parallèle des 2 logiciels",
      "Cause racine : ventilation des charges",
      "Chaque écart → test de non-régression"
    ],
    "produces": "Un cadrage → engendre des correctifs (Issues) + un Monitor live des anomalies.",
    "steps": {
      "appetite": "Appétit : « Anomalies de quittancement (pilote) » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 2 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 2 story(ies) en cours, 0 livrée(s) sur 2.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-rgpd": {
    "reframe": "Life Connect : mettre la plateforme en conformité RGPD — registre des traitements, durées de conservation, droit à l’effacement — avec cadrage juriste.",
    "synthesis": "Le module est à ~50 % développé. Reste à formaliser le registre et automatiser la purge/anonymisation à l’échéance des durées.",
    "validated": [
      "Registre des traitements à formaliser",
      "Purge/anonymisation automatique",
      "Cadrage juriste (Camille)"
    ],
    "produces": "Un socle conforme → engendre une Maintain (revue annuelle du registre).",
    "steps": {
      "appetite": "Appétit : « Conformité RGPD » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 1 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 0 story(ies) en cours, 0 livrée(s) sur 1.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-reporting": {
    "reframe": "Life Connect : livrer les états de pilotage (balances, grand livre) et les exports vers l’expert-comptable.",
    "synthesis": "Module à ~25 % : la moitié reste à développer. Enjeu : des exports équilibrés et un format directement exploitable par Agnès.",
    "validated": [
      "Balances + grand livre",
      "Export équilibré (débit = crédit)",
      "Format validé par l’expert-comptable"
    ],
    "produces": "Des états fiables → alimentent la reprise comptable & la bascule.",
    "steps": {
      "appetite": "Appétit : « États & exports comptables » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 1 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 0 story(ies) en cours, 0 livrée(s) sur 1.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-compta": {
    "reframe": "Life Connect : fiabiliser le cœur comptable (60 % développé) — plan comptable, appels de loyers, comptes-rendus — et le faire valider par l’expert-comptable (~85 % de validation experte).",
    "synthesis": "4 slices en cours : plan comptable & écritures, appels de loyers, comptes-rendus propriétaires, rapprochement bancaire. Chaque sortie passe par une revue d’Agnès.",
    "validated": [
      "Plan comptable immobilier + journaux",
      "Appels de loyers générés",
      "Validation experte sur chaque sortie"
    ],
    "produces": "Un cœur comptable fiable → engendre un Monitor des anomalies + alimente la bascule.",
    "steps": {
      "appetite": "Appétit : « Comptabilité — fiabilisation » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 4 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 3 story(ies) en cours, 0 livrée(s) sur 4.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-baux-nc": {
    "reframe": "Life Connect : livrer la gestion des baux d’habitation — modèle, cycle de vie (entrée/sortie, états des lieux), indexation, quittances. C’est le verrou fonctionnel (9 % développé).",
    "synthesis": "Orienté par le PO. Slices : modèle de bail → cycle de vie → indexation → quittances. États des lieux comparatifs entrée/sortie inclus.",
    "validated": [
      "Modèle de bail d’habitation",
      "États des lieux entrée/sortie",
      "Indexation (indice santé)"
    ],
    "produces": "Le socle baux → débloque la gestion réelle du pilote Digital Immo.",
    "steps": {
      "appetite": "Appétit : « Baux non commerciaux » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 4 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 3 story(ies) en cours, 0 livrée(s) sur 4.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-reprise-parc": {
    "reframe": "Life Connect : reprendre les données depuis SPI vers Life Connect, parc par parc, du plus petit au plus grand, jusqu’à l’arrêt de l’ancien logiciel.",
    "synthesis": "Slices : mapping SPI → modèle cible, puis imports (Digital Immo 80, Bertolo 5, ImmoCore 230, VFund 469). Contrôles de cohérence (totaux concordants) à chaque parc.",
    "validated": [
      "Mapping SPI → modèle cible",
      "Import contrôlé parc par parc",
      "Totaux concordants avec SPI"
    ],
    "produces": "Les parcs repris → débloquent la bascule comptable.",
    "steps": {
      "appetite": "Appétit : « Reprise de parc & migration » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 2 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 1 story(ies) en cours, 0 livrée(s) sur 2.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-personnes": {
    "reframe": "Life Connect : un référentiel unique des personnes (rôles multiples) + les mandats de gestion propriétaires (taux d’honoraires, périmètre).",
    "synthesis": "Module à ~52 %. La fiche unifiée gère les rôles multiples (une personne locataire ET propriétaire). Les mandats pilotent les honoraires appliqués au quittancement.",
    "validated": [
      "Fiche personne unifiée (rôles multiples)",
      "Mandats : taux d’honoraires + périmètre",
      "Honoraires appliqués au quittancement"
    ],
    "produces": "Un référentiel propre → alimente baux, compta et reporting.",
    "steps": {
      "appetite": "Appétit : « Personnes & mandats » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 2 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 1 story(ies) en cours, 0 livrée(s) sur 2.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-biens": {
    "reframe": "Life Connect : l’arborescence des biens (immeuble → lot → équipement) et le suivi des diagnostics réglementaires (DPE, amiante, électricité).",
    "synthesis": "Module à ~62 %. L’arborescence est en place ; reste le suivi des échéances de diagnostics avec alertes.",
    "validated": [
      "Arborescence immeuble → lot → équipement",
      "Suivi des validités de diagnostics",
      "Alertes d’échéance"
    ],
    "produces": "Un référentiel biens fiable → alimente baux et états.",
    "steps": {
      "appetite": "Appétit : « Biens & diagnostics » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 2 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 1 story(ies) en cours, 0 livrée(s) sur 2.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-edition": {
    "reframe": "Life Connect : la fabrique documentaire — quittances, avis d’échéance, courriers — fusionnés depuis les données et envoyés via Communication.",
    "synthesis": "Module à ~62 %, en phase de test. Les gabarits sont en place ; on fiabilise la fusion (données ↔ modèle) et l’envoi.",
    "validated": [
      "Gabarits quittance / avis / courrier",
      "Fusion données ↔ modèle",
      "Envoi via Communication"
    ],
    "produces": "Une fabrique documentaire → utilisée par baux et compta.",
    "steps": {
      "appetite": "Appétit : « Édition documentaire » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 1 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 1 story(ies) en cours, 0 livrée(s) sur 1.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-proto-portail": {
    "reframe": "Life Connect : un prototype jetable du portail locataire (quittances + déclaration d’intervention) pour valider l’usage — apprendre, pas livrer.",
    "synthesis": "Périmètre minimal : 2 écrans, données mockées, 0 backend. Objectif : décision go/no-go sur le vrai portail.",
    "validated": [
      "2 écrans (quittances + demande)",
      "Données mockées, 0 backend",
      "Décision go/no-go en fin de proto"
    ],
    "produces": "Un apprentissage → engendre (ou non) un Goal « Portail locataire ».",
    "steps": {
      "appetite": "Appétit : « Prototype portail locataire » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 1 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 1 story(ies) en cours, 0 livrée(s) sur 1.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-extranet": {
    "reframe": "Life Connect : le portail propriétaires — documents, comptes-rendus, suivi des lots. Module à 100 %, livré.",
    "synthesis": "Livré et en service. Reste à brancher les comptes-rendus de gestion produits par la compta.",
    "validated": [
      "Portail propriétaires en service",
      "Documents + suivi des lots",
      "Branchement comptes-rendus à finaliser"
    ],
    "produces": "Un portail livré → consomme les sorties de la compta.",
    "steps": {
      "appetite": "Appétit : « Extranet propriétaires » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 1 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 0 story(ies) en cours, 1 livrée(s) sur 1.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-communication": {
    "reframe": "Life Connect : la fabrique de communication — modèles e-mail et courriers (relances, avis, convocations). Module à 100 %, livré.",
    "synthesis": "Livré. Sert de canal d’envoi à l’édition documentaire et aux relances automatiques.",
    "validated": [
      "Modèles e-mail & courriers",
      "Canal d’envoi mutualisé",
      "Relances, avis, convocations"
    ],
    "produces": "Un canal d’envoi → utilisé par édition + automatisations.",
    "steps": {
      "appetite": "Appétit : « Module Communication » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 1 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 0 story(ies) en cours, 1 livrée(s) sur 1.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-maintain-plateforme": {
    "reframe": "Life Connect : garder la plateforme en marche — traiter l’entrant sous SLA et automatiser le récurrent. Réactif aux événements, pas aux métriques.",
    "synthesis": "Astreinte en place, observabilité branchée. Flux stable. 2 tâches récurrentes candidates à l’automatisation.",
    "validated": [
      "SLA P1 : 4 h (respecté)",
      "Observabilité + alertes runtime",
      "À automatiser : purge logs + renouvellement certs"
    ],
    "produces": "Plateforme stable ; incident majeur → Issue, automatisation non triviale → Goal.",
    "steps": {
      "appetite": "Appétit : « Maintenir la plateforme & astreinte » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 2 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 1 story(ies) en cours, 1 livrée(s) sur 2.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-monitor-quittancement": {
    "reframe": "Life Connect : surveiller en continu les écarts de quittancement (SPI ↔ Life Connect) et alerter dès qu’un écart dépasse le seuil — regarde vers l’intérieur, alerte.",
    "synthesis": "Check quotidien sur le pilote. Lecture actuelle : écarts résiduels en baisse. Aucune alerte critique active.",
    "validated": [
      "Seuil d’alerte : écart > 1 €/lot",
      "Check quotidien automatisé",
      "Canal : Slack #compta"
    ],
    "produces": "Alertes en temps réel ; un franchissement de seuil engendre une Issue (correctif).",
    "steps": {
      "appetite": "Appétit : « Surveiller les anomalies de quittancement » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 2 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 1 story(ies) en cours, 1 livrée(s) sur 2.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-improve-automation": {
    "reframe": "Life Connect : pousser activement la productivité (lots gérés / gestionnaire) par itérations mesurées — détection auto des erreurs, correction assistée, relances automatiques.",
    "synthesis": "Baseline actuelle estimée ~400 lots/gestionnaire. Leviers : détection+correction auto des anomalies, relances d’impayés, rapprochement bancaire. Cible : >1000.",
    "validated": [
      "Baseline ~400 lots/gestionnaire",
      "Leviers : correction auto · relances · rapprochement",
      "Cible : >1000 lots/gestionnaire"
    ],
    "produces": "Des automatisations mesurées + re-mesure continue de la productivité.",
    "steps": {
      "appetite": "Appétit : « Automatisations — viser >1000 lots/gestionnaire » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 3 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 1 story(ies) en cours, 1 livrée(s) sur 3.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-maintain-support": {
    "reframe": "Life Connect : traiter le flux de tickets (bug / évolution / question) — triage, priorisation, routage et résolution sous SLA.",
    "synthesis": "Module à ~55 %. Le triage automatique qualifie et route ; les bugs critiques (quittancement) sont escaladés en priorité.",
    "validated": [
      "Triage auto : bug / évolution / question",
      "Priorisation + routage squad",
      "Escalade des bugs critiques"
    ],
    "produces": "Tickets résolus ; bug critique → Issue, demande récurrente → automatisation.",
    "steps": {
      "appetite": "Appétit : « Support & ticketing » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 3 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 3 story(ies) en cours, 0 livrée(s) sur 3.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  },
  "lc-mis-advisory-juridique": {
    "reframe": "Life Connect : observer les évolutions réglementaires (baux commerciaux, indices, RGPD) et suggérer les adaptations produit — regarde vers l’extérieur.",
    "synthesis": "Veille hebdomadaire (juriste ponctuel). Sujet chaud : évolutions des indices commerciaux et obligations RGPD bailleur.",
    "validated": [
      "Veille hebdomadaire",
      "Sujets : indices commerciaux, RGPD bailleur",
      "Suggestions → backlog produit"
    ],
    "produces": "Des suggestions périodiques → deviennent des Goals/Issues d’adaptation.",
    "steps": {
      "appetite": "Appétit : « Veille réglementaire baux & RGPD » cadré sur un livrable clair — on vise l'essentiel, pas la sur-ingénierie.",
      "budget": "Budget : enveloppe agents (dev) + temps d'expert métier estimée et validée pour ce périmètre.",
      "scope": "Périmètre : 1 stories retenues ; le superflu est écarté ou repoussé en v1.",
      "bet": "Pari : l'équipe s'engage sur ce périmètre — on lance le build.",
      "build": "Build : 1 story(ies) en cours, 0 livrée(s) sur 1.",
      "test": "Test : batterie de tests automatisés + revue par l'agent relecteur avant mise en production.",
      "release": "Release : déployé en préview, validé, puis mis en production.",
      "demo": "Démo : prototype montré aux pilotes pour une décision go / no-go.",
      "learn": "Apprentissage : retours pilotes consolidés ; décision sur la suite.",
      "instrument": "Instrumentation : métriques et collecte en place.",
      "alerts": "Alertes : seuils armés, notifications branchées (Slack).",
      "piloting": "Pilotage : suivi quotidien, lecture des tendances.",
      "experiment": "Expérimentation : itérations mesurées en cours.",
      "measure": "Mesure : impact avant / après quantifié.",
      "optimizing": "Optimisation : itérations continues sur la métrique cible.",
      "intake": "Entrant : flux traité sous SLA, qualifié et routé.",
      "triage": "Triage : priorisation et routage des demandes.",
      "running": "Run : opéré en continu ; incidents escaladés si besoin.",
      "observe": "Observation : veille active sur l'extérieur (concurrence, réglementation).",
      "advising": "Conseil : suggestions périodiques remontées au backlog produit."
    }
  }
};

export const DISCUSSIONS_BY_MISSION_LC = {
  "lc-mis-decision-archi": [
    {
      "id": "lc-mis-decision-archi-d1",
      "title": "App unifiée résidentiel + commercial ?",
      "concepts": [
        "Socle commun ~70 %",
        "Extension commerciale",
        "Coût de maintenance"
      ],
      "messages": [
        {
          "agent": "Strategist",
          "text": "Sur les 46 besoins baux, ~70 % sont communs aux deux régimes. Un socle unifié + une extension commerciale limite la duplication.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Et le risque si les besoins divergent ?",
          "time": "09h07"
        },
        {
          "agent": "Strategist",
          "text": "Maîtrisé tant que l’extension reste isolée. Deux modules séparés ne se justifient que si le commercial explose en complexité.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-question-reprise": [
    {
      "id": "lc-mis-question-reprise-d1",
      "title": "Coût & risque de la reprise des 4 parcs ?",
      "concepts": [
        "784 lots / 4 parcs",
        "Soldes hérités",
        "Anomalies SPI"
      ],
      "messages": [
        {
          "agent": "Data Analyst",
          "text": "Le coût n’est pas dans le volume (784 lots) mais dans la fiabilisation des soldes repris : c’est là que se logent les anomalies.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "On commence par lequel ?",
          "time": "09h07"
        },
        {
          "agent": "Data Analyst",
          "text": "Digital Immo (80 lots) — le plus petit, déjà pilote. On fiabilise la méthode avant ImmoCore (230) et VFund (469).",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-idea-portail": [
    {
      "id": "lc-mis-idea-portail-d1",
      "title": "Portail locataire self-service ?",
      "concepts": [
        "Self-service",
        "−20 % sollicitations",
        "Test avant build"
      ],
      "messages": [
        {
          "agent": "Creative Strategist",
          "text": "Le besoin le plus demandé : retrouver ses quittances et déclarer un problème sans appeler. Le reste est secondaire.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "On build direct ?",
          "time": "09h07"
        },
        {
          "agent": "Creative Strategist",
          "text": "Non — un prototype jetable d’abord pour valider l’usage. C’est ce qui engendre la mission prototype.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-review-bascule": [
    {
      "id": "lc-mis-review-bascule-d1",
      "title": "Go/no-go bascule comptable (1ᵉʳ janvier)",
      "concepts": [
        "3 cycles sans anomalie",
        "Fenêtre 1ᵉʳ janvier",
        "Arrêt de SPI"
      ],
      "messages": [
        {
          "agent": "Auditor",
          "text": "Deux bloquants restent : l’écart sur les charges provisionnelles et le lettrage de 3 comptes propriétaires. Corrigibles avant la fenêtre.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Et si on rate le 1ᵉʳ janvier ?",
          "time": "09h07"
        },
        {
          "agent": "Auditor",
          "text": "La bascule glisse d’un an (fenêtre comptable annuelle). D’où l’urgence de clôturer le cycle 3 proprement.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-baux-comm": [
    {
      "id": "lc-mis-baux-comm-d1",
      "title": "Baux commerciaux (3-6-9)",
      "concepts": [
        "3-6-9",
        "ILC / ILAT",
        "Pilote Bertolo"
      ],
      "messages": [
        {
          "agent": "Project Manager",
          "text": "On découpe : spec juridique, puis clauses & révisions, puis refacturation. Bertolo sert de pilote car c’est le plus simple (2 commerciaux).",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Le juriste intervient quand ?",
          "time": "09h07"
        },
        {
          "agent": "Project Manager",
          "text": "Au cadrage (spec) et à la revue des clauses. Ponctuel mais bloquant — on l’engage tôt.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-anomalies": [
    {
      "id": "lc-mis-anomalies-d1",
      "title": "Anomalies de quittancement (pilote)",
      "concepts": [
        "Gestion parallèle",
        "Ventilation des charges",
        "Non-régression"
      ],
      "messages": [
        {
          "agent": "Auditor",
          "text": "Les écarts viennent surtout des lots à charges provisionnelles. On rapproche SPI ↔ Life Connect lot par lot.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "On bloque la bascule tant que ça saute ?",
          "time": "09h07"
        },
        {
          "agent": "Auditor",
          "text": "Oui — critère : 3 cycles sans anomalie. Chaque correctif est couvert par un test.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-rgpd": [
    {
      "id": "lc-mis-rgpd-d1",
      "title": "Conformité RGPD",
      "concepts": [
        "Registre traitements",
        "Durées de conservation",
        "Droit à l’effacement"
      ],
      "messages": [
        {
          "agent": "Auditor",
          "text": "Priorité : durées de conservation par type de donnée + purge automatique. Le reste est documentaire.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Qui valide ?",
          "time": "09h07"
        },
        {
          "agent": "Auditor",
          "text": "Le juriste valide le registre et les durées. On l’engage en ponctuel.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-reporting": [
    {
      "id": "lc-mis-reporting-d1",
      "title": "États & exports comptables",
      "concepts": [
        "Balances",
        "Grand livre",
        "Export expert"
      ],
      "messages": [
        {
          "agent": "Comptable",
          "text": "L’export doit être directement réintégrable côté expert : balance équilibrée, écritures lettrées. Sinon ça crée du retraitement.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Format ?",
          "time": "09h07"
        },
        {
          "agent": "Comptable",
          "text": "FEC + un récap par propriétaire. Je valide le gabarit avant le build.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-compta": [
    {
      "id": "lc-mis-compta-d1",
      "title": "Comptabilité — fiabilisation",
      "concepts": [
        "Plan comptable",
        "Appels de loyers",
        "Validation experte"
      ],
      "messages": [
        {
          "agent": "Comptable",
          "text": "L’ordre de fiabilisation : écritures → appels de loyers → comptes-rendus → rapprochement. On valide à chaque étape.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Le plus risqué ?",
          "time": "09h07"
        },
        {
          "agent": "Comptable",
          "text": "Les charges et la ventilation. C’est là que naissent les anomalies de quittancement.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-baux-nc": [
    {
      "id": "lc-mis-baux-nc-d1",
      "title": "Baux non commerciaux",
      "concepts": [
        "Modèle de bail",
        "États des lieux",
        "Indexation"
      ],
      "messages": [
        {
          "agent": "Project Manager",
          "text": "On part du modèle de bail, puis le cycle de vie. Les états des lieux comparatifs sont la partie la plus demandée par la gestion.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Indexation ?",
          "time": "09h07"
        },
        {
          "agent": "Project Manager",
          "text": "Indice santé, avis d’indexation automatique. Agnès valide le calcul.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-reprise-parc": [
    {
      "id": "lc-mis-reprise-parc-d1",
      "title": "Reprise de parc & migration",
      "concepts": [
        "Mapping SPI",
        "Import parc par parc",
        "Contrôle des totaux"
      ],
      "messages": [
        {
          "agent": "Engineer",
          "text": "Le mapping est la pièce maîtresse : règles de transformation + contrôles. On rejoue l’import à blanc avant chaque bascule.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Et VFund (469 lots) ?",
          "time": "09h07"
        },
        {
          "agent": "Engineer",
          "text": "En dernier — on fiabilise la méthode sur les petits parcs d’abord.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-personnes": [
    {
      "id": "lc-mis-personnes-d1",
      "title": "Personnes & mandats",
      "concepts": [
        "Fiche unifiée",
        "Mandats",
        "Honoraires"
      ],
      "messages": [
        {
          "agent": "Engineer",
          "text": "Une seule fiche par personne, plusieurs rôles. Évite les doublons locataire/propriétaire.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Les honoraires ?",
          "time": "09h07"
        },
        {
          "agent": "Engineer",
          "text": "Portés par le mandat, appliqués automatiquement au compte-rendu de gestion.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-biens": [
    {
      "id": "lc-mis-biens-d1",
      "title": "Biens & diagnostics",
      "concepts": [
        "Arborescence biens",
        "Diagnostics",
        "Échéances"
      ],
      "messages": [
        {
          "agent": "Engineer",
          "text": "Les diagnostics expirent à dates fixes — une alerte d’échéance évite les locations non conformes.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "On bloque la mise en location ?",
          "time": "09h07"
        },
        {
          "agent": "Engineer",
          "text": "On alerte, sans bloquer — la décision reste au gestionnaire.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-edition": [
    {
      "id": "lc-mis-edition-d1",
      "title": "Édition documentaire",
      "concepts": [
        "Gabarits",
        "Fusion",
        "Envoi"
      ],
      "messages": [
        {
          "agent": "Engineer",
          "text": "On teste la fusion sur les cas tordus : colocation, prorata d’entrée, charges régularisées.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Et l’envoi ?",
          "time": "09h07"
        },
        {
          "agent": "Engineer",
          "text": "Déléguée au module Communication (déjà livré) — ici on produit le document juste.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-proto-portail": [
    {
      "id": "lc-mis-proto-portail-d1",
      "title": "Prototype portail locataire",
      "concepts": [
        "Jetable",
        "2 écrans",
        "Go/no-go"
      ],
      "messages": [
        {
          "agent": "Engineer",
          "text": "Stack rapide, données mockées. On veut juste voir si les locataires comprennent le parcours quittances + demande.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "On le montre à qui ?",
          "time": "09h07"
        },
        {
          "agent": "Engineer",
          "text": "3-4 locataires du pilote Digital Immo. Retour en une semaine.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-extranet": [
    {
      "id": "lc-mis-extranet-d1",
      "title": "Extranet propriétaires",
      "concepts": [
        "Portail",
        "Documents",
        "Comptes-rendus"
      ],
      "messages": [
        {
          "agent": "Engineer",
          "text": "Module livré. Le seul reste : afficher les comptes-rendus de gestion dès qu’ils sortent de la compta.",
          "time": "08h00"
        }
      ]
    }
  ],
  "lc-mis-communication": [
    {
      "id": "lc-mis-communication-d1",
      "title": "Module Communication",
      "concepts": [
        "Modèles",
        "Envoi",
        "Relances"
      ],
      "messages": [
        {
          "agent": "Engineer",
          "text": "Module livré — c’est le canal d’envoi unique. Édition et relances auto passent par lui.",
          "time": "08h00"
        }
      ]
    }
  ],
  "lc-mis-maintain-plateforme": [
    {
      "id": "lc-mis-maintain-plateforme-d1",
      "title": "Maintenir la plateforme & astreinte",
      "concepts": [
        "Astreinte",
        "SLA P1 4h",
        "Observabilité"
      ],
      "messages": [
        {
          "agent": "DevOps",
          "text": "Astreinte + alertes runtime branchées. Le flux est stable, SLA P1 tenu.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "On automatise quoi ?",
          "time": "09h07"
        },
        {
          "agent": "DevOps",
          "text": "Purge des logs et renouvellement des certificats — du récurrent sans valeur ajoutée.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-monitor-quittancement": [
    {
      "id": "lc-mis-monitor-quittancement-d1",
      "title": "Surveiller les anomalies de quittancement",
      "concepts": [
        "Écart > 1 €/lot",
        "Check quotidien",
        "Slack #compta"
      ],
      "messages": [
        {
          "agent": "Data Analyst",
          "text": "On suit l’écart moyen par lot, jour par jour. Tendance : en baisse depuis les correctifs.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Que se passe-t-il sur alerte ?",
          "time": "09h07"
        },
        {
          "agent": "Data Analyst",
          "text": "Notif Slack #compta + une Issue de correctif. Le Monitor alerte, il ne corrige pas seul.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-improve-automation": [
    {
      "id": "lc-mis-improve-automation-d1",
      "title": "Automatisations — viser >1000 lots/gestionnaire",
      "concepts": [
        "Détection auto",
        "Correction assistée",
        ">1000 lots"
      ],
      "messages": [
        {
          "agent": "Optimizer",
          "text": "Le plus gros levier : la correction auto des anomalies détectées. Ça enlève le poste manuel #1.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "On mesure comment ?",
          "time": "09h07"
        },
        {
          "agent": "Optimizer",
          "text": "Lots gérés / gestionnaire, avant/après chaque automatisation livrée.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-maintain-support": [
    {
      "id": "lc-mis-maintain-support-d1",
      "title": "Support & ticketing",
      "concepts": [
        "Triage",
        "Routage",
        "Escalade"
      ],
      "messages": [
        {
          "agent": "Project Manager",
          "text": "Théo qualifie chaque ticket et le route. Les bugs de quittancement passent en priorité haute.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "Le SLA ?",
          "time": "09h07"
        },
        {
          "agent": "Project Manager",
          "text": "4 h sur P1, 2 jours sur le reste. On mesure le respect chaque semaine.",
          "time": "10h14"
        }
      ]
    }
  ],
  "lc-mis-advisory-juridique": [
    {
      "id": "lc-mis-advisory-juridique-d1",
      "title": "Veille réglementaire baux & RGPD",
      "concepts": [
        "Veille",
        "Indices commerciaux",
        "RGPD bailleur"
      ],
      "messages": [
        {
          "agent": "Strategic Advisor",
          "text": "À surveiller ce trimestre : la publication des nouveaux indices commerciaux et les obligations RGPD côté bailleur.",
          "time": "08h00"
        },
        {
          "user": true,
          "text": "On agit dessus ?",
          "time": "09h07"
        },
        {
          "agent": "Strategic Advisor",
          "text": "Chaque suggestion validée par le juriste devient une mission d’adaptation.",
          "time": "10h14"
        }
      ]
    }
  ]
};

export const BOARD_BY_MISSION_LC = {
  "lc-mis-review-bascule": {
    "prefix": "REVI",
    "tickets": [
      {
        "title": "Liste des décisions métier à valider",
        "status": "planned",
        "priority": "high",
        "phase": "Discovery",
        "assignee": "Andrii Khudolii",
        "labels": [],
        "description": "Plan comptable, règles de relance, déclarations : dossier à présenter aux experts."
      }
    ]
  },
  "lc-mis-baux-comm": {
    "prefix": "BAUX",
    "tickets": [
      {
        "title": "Spécification du bail commercial (3-6-9)",
        "status": "planned",
        "priority": "high",
        "phase": "Discovery",
        "assignee": "Aria",
        "labels": [],
        "description": "Durée, destination, dépôt, cession, indices."
      },
      {
        "title": "Clauses & révisions (ILC / ILAT)",
        "status": "backlog",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Aria",
        "labels": [],
        "description": "Indices commerciaux, révision triennale, échelle mobile."
      },
      {
        "title": "Pilote Bertolo (5 lots, 2 comm.)",
        "status": "backlog",
        "priority": "medium",
        "phase": "Discovery",
        "assignee": "Jennifer Bangui",
        "labels": [],
        "description": "Paramétrage du portefeuille commercial le plus simple."
      }
    ]
  },
  "lc-mis-anomalies": {
    "prefix": "ANOM",
    "tickets": [
      {
        "title": "Anomalie compta pilote — correction en boucle",
        "status": "blocked",
        "priority": "urgent",
        "phase": "Review",
        "assignee": "Tess",
        "labels": [],
        "description": "Solde propriétaire incohérent sur lots à charges provisionnelles."
      },
      {
        "title": "Écarts SPI vs Life Connect — rapprochement",
        "status": "in_progress",
        "priority": "high",
        "phase": "Review",
        "assignee": "Tess",
        "labels": [],
        "description": "Comparer les sorties des deux logiciels lot par lot ; qualifier chaque écart."
      }
    ]
  },
  "lc-mis-rgpd": {
    "prefix": "RGPD",
    "tickets": [
      {
        "title": "Registre des traitements & durées de conservation",
        "status": "planned",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Camille Roux",
        "labels": [],
        "description": "Registre, purge automatique, droit à l’effacement."
      }
    ]
  },
  "lc-mis-reporting": {
    "prefix": "REPO",
    "tickets": [
      {
        "title": "États de gestion & exports comptables",
        "status": "planned",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Cassandre",
        "labels": [],
        "description": "Balances, grand livre, export FEC vers l’expert."
      }
    ]
  },
  "lc-mis-compta": {
    "prefix": "COMP",
    "tickets": [
      {
        "title": "Plan comptable & écritures automatiques",
        "status": "in_review",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Cassandre",
        "labels": [],
        "description": "Plan comptable immobilier, journaux, écritures sur quittancement."
      },
      {
        "title": "Appels de loyers — génération",
        "status": "in_progress",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Boris",
        "labels": [],
        "description": "Échéancier, génération des appels loyers + charges, export."
      },
      {
        "title": "Comptes-rendus de gestion aux propriétaires",
        "status": "in_progress",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Cassandre",
        "labels": [],
        "description": "Reddition périodique : revenus, charges, honoraires, solde."
      },
      {
        "title": "Rapprochement bancaire",
        "status": "backlog",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Cassandre",
        "labels": [],
        "description": "Import relevés, rapprochement auto encaissements ↔ écritures."
      }
    ]
  },
  "lc-mis-baux-nc": {
    "prefix": "BAUX",
    "tickets": [
      {
        "title": "Modèle de bail non commercial",
        "status": "in_progress",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Aria",
        "labels": [],
        "description": "Parties, lot, loyer, charges, dépôt, durée."
      },
      {
        "title": "Cycle de vie du bail (entrée / sortie)",
        "status": "in_progress",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Boris",
        "labels": [],
        "description": "Entrée, congé, sortie, états des lieux comparatifs."
      },
      {
        "title": "Indexation des loyers",
        "status": "in_review",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Diego",
        "labels": [],
        "description": "Révision annuelle indexée (indice santé), avis, historique."
      },
      {
        "title": "Quittances & avis d’échéance",
        "status": "planned",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Boris",
        "labels": [],
        "description": "Édition des quittances et avis, envoi via Communication."
      }
    ]
  },
  "lc-mis-reprise-parc": {
    "prefix": "REPR",
    "tickets": [
      {
        "title": "Mapping SPI → Life Connect",
        "status": "in_progress",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Aria",
        "labels": [],
        "description": "Table de correspondance + règles de transformation et contrôles."
      },
      {
        "title": "Import des 4 parcs (~784 lots)",
        "status": "planned",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Boris",
        "labels": [],
        "description": "Digital Immo 80, Bertolo 5, ImmoCore 230, VFund Immo1 469."
      }
    ]
  },
  "lc-mis-personnes": {
    "prefix": "PERS",
    "tickets": [
      {
        "title": "Fiche personne unifiée (locataire / propriétaire / tiers)",
        "status": "in_review",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Diego",
        "labels": [],
        "description": "Référentiel unique avec rôles multiples."
      },
      {
        "title": "Mandats de gestion propriétaires",
        "status": "planned",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Diego",
        "labels": [],
        "description": "Mandats, taux d’honoraires, périmètre de lots gérés."
      }
    ]
  },
  "lc-mis-biens": {
    "prefix": "BIEN",
    "tickets": [
      {
        "title": "Arborescence immeuble → lot → équipement",
        "status": "in_progress",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Boris",
        "labels": [],
        "description": "Hiérarchie des biens et rattachement des équipements."
      },
      {
        "title": "Diagnostics & échéances réglementaires",
        "status": "planned",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Boris",
        "labels": [],
        "description": "DPE, amiante, électricité : suivi des validités."
      }
    ]
  },
  "lc-mis-edition": {
    "prefix": "EDIT",
    "tickets": [
      {
        "title": "Avis d’échéance — édition & envoi",
        "status": "in_progress",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Diego",
        "labels": [],
        "description": "Édition PDF des avis d’échéance, envoi automatique."
      }
    ]
  },
  "lc-mis-proto-portail": {
    "prefix": "PROT",
    "tickets": [
      {
        "title": "Proto : écran quittances + demande d’intervention",
        "status": "in_progress",
        "priority": "low",
        "phase": "Implementation",
        "assignee": "Diego",
        "labels": [],
        "description": "Prototype jetable, données mockées, 2 écrans."
      }
    ]
  },
  "lc-mis-extranet": {
    "prefix": "EXTR",
    "tickets": [
      {
        "title": "Portail propriétaires — documents & comptes-rendus",
        "status": "done",
        "priority": "high",
        "phase": "Review",
        "assignee": "Aria",
        "labels": [],
        "description": "Documents, comptes-rendus, suivi des lots côté propriétaire."
      }
    ]
  },
  "lc-mis-communication": {
    "prefix": "COMM",
    "tickets": [
      {
        "title": "Modèles e-mail & courriers (relances, avis)",
        "status": "done",
        "priority": "medium",
        "phase": "Review",
        "assignee": "Diego",
        "labels": [],
        "description": "Relances, avis d’échéance, convocations."
      }
    ]
  },
  "lc-mis-maintain-plateforme": {
    "prefix": "MAIN",
    "tickets": [
      {
        "title": "Infrastructure Cloudflare & accès sécurisés",
        "status": "done",
        "priority": "high",
        "phase": "Review",
        "assignee": "Aria",
        "labels": [],
        "description": "Workers/D1, CI déploiement + preview, gestion des accès."
      },
      {
        "title": "Astreinte production — semaine",
        "status": "in_progress",
        "priority": "low",
        "phase": "Review",
        "assignee": "Otto",
        "labels": [],
        "description": "Surveillance, premiers diagnostics, escalade."
      }
    ]
  },
  "lc-mis-monitor-quittancement": {
    "prefix": "MONI",
    "tickets": [
      {
        "title": "Tableau de bord des écarts de quittancement",
        "status": "done",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Otto",
        "labels": [],
        "description": "Dashboard live de l’écart moyen par lot (SPI ↔ Life Connect)."
      },
      {
        "title": "Alertes de seuil (Slack #compta)",
        "status": "in_progress",
        "priority": "medium",
        "phase": "Review",
        "assignee": "Otto",
        "labels": [],
        "description": "Alerte automatique dès qu’un écart dépasse 1 €/lot."
      }
    ]
  },
  "lc-mis-improve-automation": {
    "prefix": "IMPR",
    "tickets": [
      {
        "title": "Détection automatique des erreurs (monitoring)",
        "status": "done",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Otto",
        "labels": [],
        "description": "Tableau de bord temps réel ; socle de la correction auto."
      },
      {
        "title": "Agent de correction auto (prépare & teste le fix)",
        "status": "in_progress",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Otto",
        "labels": [],
        "description": "À la détection, un agent IA prépare et teste la correction ; validée avant prod."
      },
      {
        "title": "Relances automatiques des impayés",
        "status": "backlog",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Cassandre",
        "labels": [],
        "description": "Scénario J+5 / J+15 / mise en demeure piloté par le rapprochement."
      }
    ]
  },
  "lc-mis-maintain-support": {
    "prefix": "MAIN",
    "tickets": [
      {
        "title": "Triage des tickets entrants",
        "status": "in_progress",
        "priority": "medium",
        "phase": "Review",
        "assignee": "Théo",
        "labels": [],
        "description": "Qualification (bug/évolution/question), priorisation, routage."
      },
      {
        "title": "Bug : incohérence appels de loyers (Digital Immo)",
        "status": "in_review",
        "priority": "urgent",
        "phase": "Review",
        "assignee": "Théo",
        "labels": [],
        "description": "Montant d’appel erroné sur lots à charges provisionnelles."
      },
      {
        "title": "Bug : arrondi sur régularisation des charges",
        "status": "in_progress",
        "priority": "high",
        "phase": "Review",
        "assignee": "Otto",
        "labels": [],
        "description": "Écart d’un centime sur la ventilation par lot."
      }
    ]
  },
  "lc-mis-advisory-juridique": {
    "prefix": "ADVI",
    "tickets": [
      {
        "title": "Veille réglementaire hebdomadaire",
        "status": "in_progress",
        "priority": "low",
        "phase": "Review",
        "assignee": "Camille Roux",
        "labels": [],
        "description": "Revue hebdo des évolutions baux/indices/RGPD, suggestions au backlog."
      }
    ]
  }
};

export const SQUAD_BY_MISSION_LC = {
  "lc-mis-review-bascule": {
    "lead": {
      "name": "Andrii Khudolii",
      "champion_slug": null,
      "role": "Développeur"
    },
    "permanent": [
      {
        "name": "Jennifer Bangui",
        "champion_slug": null,
        "role": "Product Owner"
      },
      {
        "name": "Agnès Descamps",
        "champion_slug": null,
        "role": "Comptable"
      }
    ],
    "temporary": []
  },
  "lc-mis-baux-comm": {
    "lead": {
      "name": "Aria",
      "champion_slug": "aria-architect",
      "role": "architect"
    },
    "permanent": [
      {
        "name": "Camille Roux",
        "champion_slug": null,
        "role": "Juriste"
      },
      {
        "name": "Jennifer Bangui",
        "champion_slug": null,
        "role": "Product Owner"
      },
      {
        "name": "Boris",
        "champion_slug": "boris-builder",
        "role": "implementer"
      }
    ],
    "temporary": []
  },
  "lc-mis-anomalies": {
    "lead": {
      "name": "Tess",
      "champion_slug": "tess-tester",
      "role": "tester"
    },
    "permanent": [
      {
        "name": "Boris",
        "champion_slug": "boris-builder",
        "role": "implementer"
      },
      {
        "name": "Agnès Descamps",
        "champion_slug": null,
        "role": "Comptable"
      }
    ],
    "temporary": []
  },
  "lc-mis-rgpd": {
    "lead": {
      "name": "Camille Roux",
      "champion_slug": null,
      "role": "Juriste"
    },
    "permanent": [
      {
        "name": "Aria",
        "champion_slug": "aria-architect",
        "role": "architect"
      }
    ],
    "temporary": []
  },
  "lc-mis-reporting": {
    "lead": {
      "name": "Cassandre",
      "champion_slug": "cassandre-accounting",
      "role": "accounting"
    },
    "permanent": [
      {
        "name": "Agnès Descamps",
        "champion_slug": null,
        "role": "Comptable"
      },
      {
        "name": "Jennifer Bangui",
        "champion_slug": null,
        "role": "Product Owner"
      }
    ],
    "temporary": []
  },
  "lc-mis-compta": {
    "lead": {
      "name": "Cassandre",
      "champion_slug": "cassandre-accounting",
      "role": "accounting"
    },
    "permanent": [
      {
        "name": "Agnès Descamps",
        "champion_slug": null,
        "role": "Comptable"
      },
      {
        "name": "Raphaël",
        "champion_slug": "rapha-reviewer",
        "role": "reviewer"
      },
      {
        "name": "Boris",
        "champion_slug": "boris-builder",
        "role": "implementer"
      }
    ],
    "temporary": []
  },
  "lc-mis-baux-nc": {
    "lead": {
      "name": "Aria",
      "champion_slug": "aria-architect",
      "role": "architect"
    },
    "permanent": [
      {
        "name": "Jennifer Bangui",
        "champion_slug": null,
        "role": "Product Owner"
      },
      {
        "name": "Boris",
        "champion_slug": "boris-builder",
        "role": "implementer"
      },
      {
        "name": "Diego",
        "champion_slug": "diego-dev",
        "role": "implementer"
      },
      {
        "name": "Agnès Descamps",
        "champion_slug": null,
        "role": "Comptable"
      }
    ],
    "temporary": []
  },
  "lc-mis-reprise-parc": {
    "lead": {
      "name": "Aria",
      "champion_slug": "aria-architect",
      "role": "architect"
    },
    "permanent": [
      {
        "name": "Andrii Khudolii",
        "champion_slug": null,
        "role": "Développeur"
      },
      {
        "name": "Boris",
        "champion_slug": "boris-builder",
        "role": "implementer"
      },
      {
        "name": "Diego",
        "champion_slug": "diego-dev",
        "role": "implementer"
      }
    ],
    "temporary": []
  },
  "lc-mis-personnes": {
    "lead": {
      "name": "Diego",
      "champion_slug": "diego-dev",
      "role": "implementer"
    },
    "permanent": [
      {
        "name": "Jennifer Bangui",
        "champion_slug": null,
        "role": "Product Owner"
      },
      {
        "name": "Agnès Descamps",
        "champion_slug": null,
        "role": "Comptable"
      }
    ],
    "temporary": []
  },
  "lc-mis-biens": {
    "lead": {
      "name": "Boris",
      "champion_slug": "boris-builder",
      "role": "implementer"
    },
    "permanent": [
      {
        "name": "Jennifer Bangui",
        "champion_slug": null,
        "role": "Product Owner"
      }
    ],
    "temporary": []
  },
  "lc-mis-edition": {
    "lead": {
      "name": "Diego",
      "champion_slug": "diego-dev",
      "role": "implementer"
    },
    "permanent": [],
    "temporary": []
  },
  "lc-mis-proto-portail": {
    "lead": {
      "name": "Diego",
      "champion_slug": "diego-dev",
      "role": "implementer"
    },
    "permanent": [
      {
        "name": "Aria",
        "champion_slug": "aria-architect",
        "role": "architect"
      }
    ],
    "temporary": []
  },
  "lc-mis-extranet": {
    "lead": {
      "name": "Aria",
      "champion_slug": "aria-architect",
      "role": "architect"
    },
    "permanent": [
      {
        "name": "Boris",
        "champion_slug": "boris-builder",
        "role": "implementer"
      }
    ],
    "temporary": []
  },
  "lc-mis-communication": {
    "lead": {
      "name": "Diego",
      "champion_slug": "diego-dev",
      "role": "implementer"
    },
    "permanent": [],
    "temporary": []
  },
  "lc-mis-maintain-plateforme": {
    "lead": {
      "name": "Aria",
      "champion_slug": "aria-architect",
      "role": "architect"
    },
    "permanent": [
      {
        "name": "Boris",
        "champion_slug": "boris-builder",
        "role": "implementer"
      },
      {
        "name": "Andrii Khudolii",
        "champion_slug": null,
        "role": "Développeur"
      },
      {
        "name": "Otto",
        "champion_slug": "otto-oncall",
        "role": "support"
      }
    ],
    "temporary": []
  },
  "lc-mis-monitor-quittancement": {
    "lead": {
      "name": "Otto",
      "champion_slug": "otto-oncall",
      "role": "support"
    },
    "permanent": [
      {
        "name": "Andrii Khudolii",
        "champion_slug": null,
        "role": "Développeur"
      },
      {
        "name": "Agnès Descamps",
        "champion_slug": null,
        "role": "Comptable"
      }
    ],
    "temporary": []
  },
  "lc-mis-improve-automation": {
    "lead": {
      "name": "Otto",
      "champion_slug": "otto-oncall",
      "role": "support"
    },
    "permanent": [
      {
        "name": "Andrii Khudolii",
        "champion_slug": null,
        "role": "Développeur"
      },
      {
        "name": "Tess",
        "champion_slug": "tess-tester",
        "role": "tester"
      },
      {
        "name": "Cassandre",
        "champion_slug": "cassandre-accounting",
        "role": "accounting"
      }
    ],
    "temporary": []
  },
  "lc-mis-maintain-support": {
    "lead": {
      "name": "Théo",
      "champion_slug": "theo-triage",
      "role": "bug-triage"
    },
    "permanent": [
      {
        "name": "Boris",
        "champion_slug": "boris-builder",
        "role": "implementer"
      },
      {
        "name": "Tess",
        "champion_slug": "tess-tester",
        "role": "tester"
      },
      {
        "name": "Otto",
        "champion_slug": "otto-oncall",
        "role": "support"
      }
    ],
    "temporary": []
  },
  "lc-mis-advisory-juridique": {
    "lead": {
      "name": "Camille Roux",
      "champion_slug": null,
      "role": "Juriste"
    },
    "permanent": [],
    "temporary": []
  }
};
